// extracted by mini-css-extract-plugin
export default {"container":"src-components-Modules-ProductGridDisplay-css__container--H6KJa","colorPickerWidth":"src-components-Modules-ProductGridDisplay-css__colorPickerWidth--ydK67"};